export default __webpack_public_path__ + "static/char-v-14-d131b06ef0aa3dada55ab9ea1c1fef3e.mp4";